import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { ClassNames } from '@emotion/react';
import { GridContainer } from '@lusha-ui/core';
import { zIndexPolicy } from '@lusha-ui/theme';
import React, { useEffect, useMemo } from 'react';
import Modal from 'react-modal';
import { KeyContextProvider } from 'use-key-context';
import ModalCloseButton from './ModalCloseButton';
function ModalStyled(props) {
    const { isVisible, onClose, children, className, hideCloseButton, name, wrapperPadding = 24 } = props;
    const testId = useMemo(() => (name ? `modal/${name}` : ''), [name]);
    useEffect(() => {
        if (isVisible) {
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.overflow = 'unset';
        }
    }, [isVisible]);
    return (_jsx(KeyContextProvider, { value: testId, children: _jsx(ClassNames, { children: ({ css }) => (_jsxs(Modal, { isOpen: isVisible, onRequestClose: onClose, overlayClassName: css `
              background: rgba(21, 20, 23, 0.4);
              inset: 0;
              position: fixed;
              z-index: ${zIndexPolicy.bigModal};
              display: flex;
              align-items: flex-start;
              justify-content: center;
            `, css: css `
              min-width: 304px;
              max-width: 304px;
              border-radius: 8px;
              padding: 0;
              background: #fff;
              outline: none;
              position: relative;
              margin-top: 14px;
            `, className: className, children: [!hideCloseButton && (_jsx(GridContainer, { justifyContent: 'flex-end', css: css `
                  padding: 8px;
                `, children: _jsx(ModalCloseButton, { onClose: onClose }) })), _jsx("div", { css: css `
                padding: 0 ${wrapperPadding}px ${wrapperPadding}px;
              `, children: children })] })) }) }));
}
export default ModalStyled;
